import React, { useEffect, useRef, useState } from "react";
import { MdVolumeDown, MdVolumeUp } from "react-icons/md";

const NotificationsVolume = ({ volume, setVolume }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const normalizedVolume = Number(volume ?? 0);

  const handleClick = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleVolumeChange = (event) => {
    const value = Number(event.target.value);
    setVolume(value);
    localStorage.setItem("volume", value);
  };

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  return (
    <div className="relative h-full w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={handleClick}
        aria-label="Abrir controle de volume"
        className="flex h-full w-full cursor-pointer items-center justify-center rounded-[10px] border-0 bg-transparent p-0 text-inherit outline-none transition-colors hover:bg-farmazon-hover"
      >
        <MdVolumeUp size={20} />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full z-[1300] mt-2 w-[250px] rounded-xl border border-farmazon-border bg-farmazon-surface px-4 py-3 shadow-xl">
          <div className="flex items-center gap-3">
            <MdVolumeDown className="shrink-0 text-xl text-farmazon-text-muted" />
            <input
              type="range"
              aria-label="Volume das notificações"
              min="0"
              max="1"
              step="0.1"
              value={normalizedVolume}
              onChange={handleVolumeChange}
              className="h-1.5 flex-1 cursor-pointer appearance-none rounded-full bg-farmazon-surface-muted accent-red-500 outline-none"
            />
            <MdVolumeUp className="shrink-0 text-xl text-farmazon-text-muted" />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsVolume;
